









































import Vue from 'vue'
import moment from 'moment/moment'
import { Icon, Toast } from 'vant';
import adminService from "@/service/adminService";
export default Vue.extend({
  components: {
    Icon
  },

  watch: {
    type() {
      this.getData()
    }

  },
  data() {
    return {
      type: '温棚',
      growPeriod: '',
      data: undefined,
      active: 0
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      adminService.getGrowthPeriod(this.type).then((res: any) => {
        if (res && res.growType) {
          this.growPeriod = res
          adminService.getGrowthSystem(res.growType).then((res1: any) => {
            if (res1) {
              this.data = res1
            }
          })
        }



      })
    }

  },
  filters: {
    dtFormat(datetime: number) {
      const time = moment(datetime, 'YYYYMMDDHHmmss')
      return time.add(8, 'hours').format('YYYY年M月D日HH时mm分')
    }
  }
})
